// removed by extract-text-webpack-plugin
module.exports = {"block":"_28YR2U1nJIvQ6dIGYNn6wM","heading":"_3Nn8vMbAzybV0iRObMV14j","list":"_1f4CJnnTlGM_kF-kbtO3t","link":"_1aHYqsiApP6cnX50IEeaWV","listItem":"_28oSiEK_fMlNlSPueTnLlg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupWithLinksBlock/GroupWithLinksBlock.module.scss
// module id = 771
// module chunks = 0